<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-select
        size="medium"
        v-model="searchForm.poolId"
        placeholder="请选择矿池"
        @change="getTableList"
        clearable 
      >
        <el-option
          v-for="item in pollList"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        ></el-option>
      </el-select>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
      <el-table-column
        type="index"
        width="60px"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="incomeDate"
        label="时间">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="节点总收益(FIL)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.coinIncome,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="nodePower"
        label="总存储数(TiB)">
      </el-table-column>
      <el-table-column
        prop="unitIncome"
        label="每T收益(FIL)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.unitIncome,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gas"
        label="Gas">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="burn"
        label="惩罚值">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.burn,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="100px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="goDetl(scope.row.id)"><i class="el-icon-view" style="margin-right:3px;"></i>查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="节点收益明细"
      :visible.sync="dialogVisible"
      width="600px">
      <el-table
        border
        :data="nodeTableList"
        style="width: 100%">
        <!-- <el-table-column
          width="160"
          label="充币时间">
          <template slot-scope="scope">
            <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
          </template>
        </el-table-column> -->
          <el-table-column
            prop="nodeNumber"
            label="节点名称">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="当前收益(FIL)">
            <template slot-scope="scope">
              <span>{{$selfFunc.toNonExponential(scope.row.coinIncome,4)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="nodePower"
            label="总存储数(TiB)">
          </el-table-column>
          <el-table-column
            prop="gas"
            label="Gas">
            <template slot-scope="scope">
              <span>{{$selfFunc.toNonExponential(scope.row.gas,4)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="burn"
            label="惩罚值">
            <template slot-scope="scope">
              <span>{{$selfFunc.toNonExponential(scope.row.burn,4)}}</span>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        poolId: null,
        startTime: null,
        endTime: null,
      },
      tableData: [],
      pollList: [],
      dialogVisible: false,
      nodeTableList:[]
    };
  },
  created() {
    this.poolAll()
    
  },
  methods: {
    async poolAll(){
      let res = await this.$http.nodePoolAll()
      if (res) {
        this.searchForm.poolId = res.data[0].id
        res.data.map((x)=>{
          this.pollList.push({
            key: x.id,
            label: x.name
          })
        })
        this.getTableList()
      }
    },
    async goDetl(id) {
      this.dialogVisible = true
      let res = await this.$http.nodeIncomeDetails({poolIncomeId:id});
      if (res) {
        this.nodeTableList = res.data
        
      }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.nodePoolIncomeRecords({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
